import { render } from "./FormActivity.vue?vue&type=template&id=4574d89b&ts=true"
import script from "./FormActivity.vue?vue&type=script&lang=ts"
export * from "./FormActivity.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__